import { combineReducers } from "redux";

import a5Reducer from "./a5Reducers";
import alertReducer from "./alertReducers";
import authReducer from "./authReducer";
import calendarReducer from "./calendarReducer";
import configsReducer from "./configsReducer";
import { crisisRiskReducer } from "./reportReducers";
import dynamicRouteConfigReducer from "./dynamicRouteConfigReducer";
import exceptionReportingReducer from "./exceptionReportReducers";
import featureFlagReducer from "./featureFlagReducer";
import { insuranceReducer } from "./insuranceReducers";
import loaderReducer from "./loaderReducer";
import { patientCardInfoReducer } from "./patientCardInfoReducers";
import patientReducer from "./patientReducers";
import { paymentProcessorReducer } from "./paymentProcessorReducers";
import providerReducer from "./providerReducers";
import { toasterReducer } from "./toasterReducers";

export default combineReducers({
  auth: authReducer,
  loader: loaderReducer,
  patient: patientReducer,
  provider: providerReducer,
  alert: alertReducer,
  dynamicRouteConfig: dynamicRouteConfigReducer,
  exceptionReport: exceptionReportingReducer,
  a5Screening: a5Reducer,
  configs: configsReducer,
  calendar: calendarReducer,
  reports: {
    crisisRisk: crisisRiskReducer,
  },
  insurance: insuranceReducer,
  patientCardInfo: patientCardInfoReducer,
  paymentProcessor: paymentProcessorReducer,
  toaster: toasterReducer,
  flags: featureFlagReducer,
});
